import React from "react";
import CircularProgress from "@mui/material/CircularProgress";

interface ButtonProps {
  text: string;
  width?: string;
  textColor?: string;
  onClick?: () => void;
  bg: string;
  disabled?: boolean;
  loading?: boolean;
  type?: "button" | "submit" | "reset";
}

const Button = ({
  text,
  type,
  textColor,
  width,
  onClick,
  bg,
  disabled,
  loading,
  ...rest
}: ButtonProps) => {
  return (
    <div>
      <button
        onClick={onClick}
        type={type}
        className={`bg-${bg} w-${width}  px-2 py-3 rounded text-center h-[50px] cursor-pointer transition text-lightDark duration-300 ease-in-out hover:text-white hover:bg-opacity-80`}
      >
        {loading ? (
          <CircularProgress size={20} />
        ) : (
          <p className={`text-${textColor} hover:text-white`}>{text}</p>
        )}
      </button>
    </div>
  );
};
export default Button;
